import Refresh from "@mui/icons-material/Refresh";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import PrintIcon from "../../../images/icons/PrintIcon.svg";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DialogPopup } from "../../../components/DialogPopup";
import AlertInfoIcon from "../../../images/icons/AlertInfoIcon.svg";
import {
  AlertPurple,
  BtnGroupStyle,
  BtnIconStyle,
  DataGridListStyle,
} from "../../../Theme";
import { v4 as uuid } from "uuid";
import { YSButton } from "../../../uikit/YSButton";
import { loadingEPAWorklistDetails } from "../../../Redux/Slice/EPAWorklistDetailsSlice";
import NoRecords from "../../../components/NoRecords";
import {
  DrugTextNTooltip,
  EPAStatusDetails,
  TextNTooltip,
} from "../../../components/Content";
import ErrorOverlay from "../../../components/ErrorOverlay";
import YSSnackBar from "../../../uikit/YSSnackBar";
import {
  EPAHoldingQueuePrint,
  EPATokenAcceleratorIFrame,
} from "../../../Apis/AuthApiServices";
import { REPORT_BASE_URL } from "../../../Apis/Constants";
import { TextOnly } from "../../../components/Content";

export default function EPAWorklistDetails(props: any) {
  const { mxvalue, docId, docName, setShowFlow } = props;
  const [oaPopup, setOAPopup] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [rowData, setRowData] = useState({});
  const [selectionData, setSelectionData] = useState("");
  const [printLoad, setPrintLoad] = useState(false);
  const [printActive, setPrintActive] = useState(false);
  const [reportUrl, setReportUrl] = useState("");
  const [StateData, SetStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });

  const doctorId: any = localStorage.getItem("doctorId");

  const handleShowOAPopupClick = () => {
    setOAPopup(true);
  };
  const handleHideOAPopupClick = () => {
    setOAPopup(false);
  };
  const [EPAStatusPopup, setEPAStatusPopup] = useState(false);
  const handleShowEPAStatusPopupClick = () => {
    setEPAStatusPopup(true);
  };
  const handleHideEPAStatusPopupClick = () => {
    setEPAStatusPopup(false);
  };
  const columnsEPAWorklistDetails: GridColDef[] = [
    {
      field: "patientName",
      headerName: "Patient",
      width: 150,
      cellClassName: "w20",
      headerClassName: "w20",
      renderCell: (params: any) => <TextOnly Text={params.value} />,
    },
    {
      field: "drugName",
      headerName: "Drug",
      width: 180,
      cellClassName: "w20",
      headerClassName: "w20",
      renderCell: ({ row }) => <DrugTextNTooltip row={row} />,
    },
    {
      field: "pharmacyName",
      headerName: "Pharmacy",
      width: 180,
      cellClassName: "w20",
      headerClassName: "w20",
      renderCell: (params: any) => <TextNTooltip Text={params.value} />,
    },
    {
      field: "epaCreatedDate",
      headerName: "Date",
      width: 100,
      cellClassName: "w12",
      headerClassName: "w12",
      renderCell: (params: any) => <TextOnly Text={params.value} />,
    },
    {
      field: "Status",
      headerName: "Status",
      width: 140,
      cellClassName: "w20",
      headerClassName: "w20",
      renderCell: ({ row }) => (
        <Typography
          component="div"
          color="primary"
          variant="body2"
          onClick={() => {
            handleShowEPAStatusPopupClick();
            setRowData(row);
          }}
        >
          {row.overallEpaStatus + "-" + row.currentStatus}
        </Typography>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      cellClassName: "w30",
      headerClassName: "w30",
      renderCell: ({ row }) => (
        <>
          <Box style={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <Typography
              component="div"
              color="primary"
              variant="body2"
              onClick={() => {
                getOpenAccelerator(row);
                handleShowOAPopupClick();
              }}
              marginRight={3}
            >
              Open Accelerator{" "}
            </Typography>
          </Box>
        </>
      ),
    },
  ];

  const epaPrint = async (epaId: any) => {
    try {
      setPrintLoad(true);
      const bodyData = {
        epaId: epaId[0],
        function: "worklist",
        userDetails: {
          userId: "",
          doctorId: doctorId,
          onBehalfDoctorId: docId,
          selectedClinicId: sessionStorage.getItem("clinicId") ?? "",
        },
      };

      const result = await EPAHoldingQueuePrint(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setReportUrl(result?.data?.response[0]?.reportUrl);
        setPrintActive(true);
        setPrintLoad(false);
      } else {
        setReportUrl("");
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
        setPrintLoad(false);
      }
    } catch (error) {
      setReportUrl("");
      SetStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong",
          variant: "error",
          open: true,
        };
      });
      setPrintLoad(false);
    }
  };

  const EPAWorklistDetailsState = useSelector((state: any) => {
    return { ...state.EPAWorklistDetailsSlice };
  }); //redux data

  const MainDoctor = localStorage.getItem("DoctorName");
  const [rowCountState, setRowCountState] = useState(
    EPAWorklistDetailsState?.Pagination?.totalItems || 0
  );

  const dispatch = useDispatch();
  const EPAWorklistDetailsPage = (nextPage: number) => {
    let paramsData = {
      pageNumber: nextPage,
      pageSize: pageSize,
      prescriptionType: mxvalue,
      doctorId: docId,
    };
    dispatch(loadingEPAWorklistDetails(paramsData));
  };

  useEffect(() => {
    EPAWorklistDetailsPage(page);
  }, [page, mxvalue]);

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      EPAWorklistDetailsState?.Pagination?.totalItems !== undefined
        ? EPAWorklistDetailsState?.Pagination?.totalItems
        : prevRowCountState
    );
  }, [EPAWorklistDetailsState?.Pagination?.totalItems, setRowCountState]);

  const formRef: any = useRef(null);
  const [AcceleratorData, setAcceleratorData] = useState<any>([]);
  const [iFrameDetails, setIframeDetails] = useState("");
  const getOpenAccelerator = async ({
    doctorId,
    personPrescriptionEpaId,
  }: any) => {
    try {
      const params = new URLSearchParams();
      params.append("doctorId", doctorId);
      params.append("epaId", personPrescriptionEpaId);
      const result = await EPATokenAcceleratorIFrame(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setAcceleratorData(result?.data?.response);
      } else {
        setAcceleratorData([]);
      }
    } catch (er) {
      setAcceleratorData([]);
    }
  };
  useEffect(() => {
    formRef?.current?.submit();
  }, [AcceleratorData]);
  return (
    <>
      <Grid
        item
        xs={12}
        md={6}
        textAlign={{ xs: "center", md: "right", lg: "right" }}
      >
        <Box
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            columnGap: 10,
            marginRight: 100,
          }}
        >
          <Typography component="span" color="primary" variant="body2">
            Provider
          </Typography>{" "}
          <Typography component="span" variant="body2">
            {docName === "My Own Prescriptions"
              ? MainDoctor?.toUpperCase()
              : docName?.toUpperCase()}
          </Typography>{" "}
          <BtnIconStyle className="refresh">
            <Tooltip title="Refresh">
              <IconButton
                color="primary"
                onClick={() => {
                  EPAWorklistDetailsPage(page);
                }}
              >
                <Refresh />
              </IconButton>
            </Tooltip>{" "}
          </BtnIconStyle>
        </Box>{" "}
      </Grid>
      <Grid item xs={12} marginBottom={1}>
        <AlertPurple>
          <img src={AlertInfoIcon} alt="alert" loading="lazy" />
          <Typography component="span" variant="body2">
            Purple color status says that “Acknowledgement is required via
            accelerator to complete the process”.
          </Typography>
        </AlertPurple>
      </Grid>
      <Grid item xs={12} marginBottom={1}>
        {printActive ? (
          <>
            <Grid item xs={12}>
              <iframe
                src={`${REPORT_BASE_URL}${reportUrl}`}
                height="500px"
                width="100%"
                title="PrintReport"
              />
            </Grid>
            <Grid item xs={12}>
              <BtnGroupStyle className="right">
                <YSButton
                  className=""
                  children={"Back"}
                  variant={"outlined"}
                  size={"large"}
                  onClick={() => {
                    setPrintActive(false);
                    setSelectionData("");
                  }}
                />{" "}
              </BtnGroupStyle>
            </Grid>
          </>
        ) : (
          <>
            <DataGridListStyle>
              <DataGrid
                rows={EPAWorklistDetailsState?.Items ?? []}
                headerHeight={36}
                sortingOrder={["desc", "asc"]}
                columns={columnsEPAWorklistDetails}
                // style={{ height: 600, overflow: "auto" }}
                autoHeight
                rowHeight={40}
                pageSize={pageSize}
                disableSelectionOnClick
                checkboxSelection
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                paginationMode="server"
                getRowId={(row) => row.personPrescriptionEpaId ?? uuid()}
                loading={EPAWorklistDetailsState.isLoading}
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                error={EPAWorklistDetailsState?.error || undefined}
                rowCount={rowCountState}
                page={page}
                rowsPerPageOptions={[pageSize]}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
                onSelectionModelChange={(ids: any) => {
                  setSelectionData(ids);
                }}
              />
            </DataGridListStyle>
            <Grid item xs={12} my={2}>
              <BtnGroupStyle className="middle">
                <YSButton
                  className=""
                  children={"Back"}
                  variant={"outlined"}
                  size={"large"}
                  onClick={() => {
                    setShowFlow(false);
                  }}
                />{" "}
                <YSButton
                  children={
                    printLoad ? (
                      <CircularProgress color="primary" size={28} />
                    ) : (
                      "Print"
                    )
                  }
                  onClick={() => {
                    if (selectionData.length === 1) {
                      epaPrint(selectionData);
                    } else {
                      SetStateData((prevState: any) => {
                        return {
                          ...prevState,
                          message:
                            "Please select only one EPA Worklist to print.",
                          variant: "error",
                          open: true,
                        };
                      });
                    }
                  }}
                  variant={"outlined"}
                  size={"large"}
                  startIcon={<img src={PrintIcon} alt="print" loading="lazy" />}
                />{" "}
              </BtnGroupStyle>
            </Grid>{" "}
          </>
        )}
      </Grid>
      <DialogPopup
        windowsize={"md"}
        show={oaPopup}
        handleShowPopupClick={handleShowOAPopupClick}
        handleHidePopupClick={handleHideOAPopupClick}
        close={true}
      >
        <form
          action={
            iFrameDetails
              ? iFrameDetails
              : AcceleratorData[0]?.actionDetailsForWorklist
          }
          method="post"
          ref={formRef}
          target="launchIframe"
          id="iframeFormId"
        >
          <Grid container spacing={0}>
            <input
              type="hidden"
              name="authToken"
              value={AcceleratorData[0]?.authToken}
            />
            <Grid item xs={12} md={4}>
              <YSButton
                children="Launch Work List"
                variant="contained"
                type="submit"
                onClick={() => {
                  setIframeDetails(AcceleratorData[0]?.actionDetailsForProcess);
                }}
                size="medium"
                className=""
              />
            </Grid>
            <Grid item xs={12} md={4} textAlign="center">
              <YSButton
                children="View Process Details"
                variant="contained"
                type="submit"
                onClick={() => {
                  setIframeDetails(AcceleratorData[0]?.actionDetailsForProcess);
                }}
                size="medium"
                className=""
              />
            </Grid>
          </Grid>
        </form>

        <Grid item xs={12} textAlign="center" marginTop={1} className="btns">
          <iframe
            title="iframe"
            id="iframeFormId"
            name="launchIframe"
            width={800}
            height={400}
            loading="lazy"
          />
        </Grid>
      </DialogPopup>

      <DialogPopup
        title="EPA Status Details"
        windowsize={"sm"}
        show={EPAStatusPopup}
        handleShowPopupClick={handleShowEPAStatusPopupClick}
        handleHidePopupClick={handleHideEPAStatusPopupClick}
      >
        <EPAStatusDetails rowData={rowData} />
      </DialogPopup>
      <YSSnackBar
        message={StateData.message}
        variant={StateData.variant}
        open={StateData.open}
        handleClose={() => {
          SetStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
